import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";
import {Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import {config} from "../../../utility/swaggerClient";
import { Control, LocalForm, Errors } from 'react-redux-form';
import { setStatic } from 'recompose';

const ModalExample3 = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    stagingprj,
    store,
    dfuserList,
    dfuser,
    userlistnotindf,
    callback,
    // dfuserfromdropdown,
    // setState
   // setDfuserfromdropdown
  } = props;

  const [modal, setModal] = useState(false);
  const [infoText, setInfoText] = useState("Select source code staging project names:");
  const [warningText, setWarningText] = useState("Exception");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMesssage] = useState("");
   const [dfuserfromdropdown, setDfuserfromdropdown] = useState("");
 // const [dfuserList,setdDfuserList] = useState([]);


  

  const  selectDdfuser = (e)=>{ 
    //setDfuser(e.target.value);

   setDfuserfromdropdown(e.target.value);
   // setState({dfuserfromdropdown:e.target.value});
    console.log(dfuserfromdropdown);
  };
  

  const toggle = () => setModal(!modal);

  const close = ()=>{
    // let body ={};
    // if(true){
    //     body=JSON.stringify({
    //           dfuserid : dfuser,
    //           // companyName: company,
    //           // corporateEmail: email,
    //           // message
    //         })
    // }else{
    //   body=JSON.stringify({
    //     firstNameAndLastName : store.getState().shift.auth.firstname + store.getState().shift.auth.lastname,
    //     companyName: store.getState().shift.auth.customerid,
    //     corporateEmail: store.getState().shift.auth.email,
    //     message
    //   })
    // }

    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    //   body
    // };
    // fetch(`${config.protocol}://${config.host}/api/user/contactus`, requestOptions)
    //   .then(data => {
    //     console.log(data);
    //     toggle();
    //   });


console.log(dfuser);
toggle();
//this.setdDfuserList(dfuserList => [...dfuserList, dfuser]);
    //approve =()=>{
     //  msg = `The organization ${this.state.companyname} has been approved. An email notification has been sent to the organization’s admin user.`
     // this.setState({confirmationText : msg, modalsize: "modal_sm"});
     // this.props.dfuserApprove(this.state.userid,this.openModal);
   // };
  }


  const closeSubmit = ()=>{
    callback(dfuserfromdropdown);
    toggle();
  }

  console.log("3333")
  useEffect(() => {
   // getuserlistnotindf(props.match.params.customerid,props.match.params.dfid);
  }, []);

  return (

    <a>
      <div style={{cursor: 'pointer', display: 'inline-block',}}
    //   backgroundColor:"#5e7a2b", marginBottom:'5px',height:'42px',width:'120px', 
    //   fontsize: '14px',
    // borderradius: '4px',
    // bordestyle: 'solid',
    // borderwidth: '1px',
    // borderradius: '4px',
    // backgroundcolor: '#5e7a2b',}}
       onClick={toggle}> {buttonLabel}</div>
      {/* <Button className="button asse_upload" style={{backgroundColor:"#5e7a2b", marginBottom:'5px',height:'42px',width:'120px'}} onClick={toggle}>{buttonLabel}</Button> */}
      <Modal isOpen={modal} toggle={toggle} className={className} >
        {hasTitle && (
          <ModalHeader toggle={toggle}>
            <div style={{width: "450px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/>
            <i>Add an Existing User </i>
            </div>
            {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className="modal_logo"/>{warningText} </div>)}
          </ModalHeader>
        )}
        <ModalBody style={{overflow:'auto'}}>
        <LocalForm
                    className="form"
                    // onSubmit={() =>
                    //   props.clickSubmitHandler(
                    //     props.username
                    //     // props.repo,
                    //     // srclang,
                    //     // targetLanguage,
                    //     // description,
                    //     // jobType,
                    //     // stagingrepo,
                    //     // customer,
                                           
                    //   )
                    // }
                  >
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="pick.use"
                            defaultMessage="Pick an User"
                          />
                        </label>

                        <Control.select
                         // model=".dfuser"
                         model=".dfuserfromdropdown"
                          autoFocus
                          required
                          value={dfuserfromdropdown}
                         onChange={selectDdfuser}
                        //  onChange = {(e)=>{setMesssage(e.target.value)}}
                        >
                          {/* {(customer === "" || customer === null) && <option value="">Please select JDBC Driver</option>} */}
                          <option value="">Please select a user</option> 
                         
                          {userlistnotindf.map(item => (
                            <option key={item.id} value={item.id}>
                              {item.username}
                            </option>
                          ))}

                     
                        </Control.select>
                      </fieldset>
                      </div>
      </LocalForm>
          {/* <Form>
            {true && (
              <div>
                <FormGroup>
                  <Input placeholder="First and Last Name" value={name} onChange={(e)=>{setName(e.target.value)}}/>
                </FormGroup>
                <FormGroup>
                <Input placeholder="Company Name" value={company} onChange={(e)=>{setCompany(e.target.value)}}/>
                </FormGroup>
                <FormGroup>
                <Input type="email" placeholder="Corporate Email" value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                </FormGroup>
              </div>
            )}


            <FormGroup>
              <Input type="textarea"  placeholder="Message" style={{height: '200px'}}
                     value={message}
                     onChange = {(e)=>{setMesssage(e.target.value)}}
              />
            </FormGroup>
          </Form> */}
        </ModalBody>
        <ModalFooter>
          {(info || warning) &&(
            <div
            className="button-container"
            style={{ textAlign: 'center',marginRight:'158px' }}
          > 
            <button
            className="button"
            style={{ marginLeft : "auto", marginRight : "10px"}}
            type="button"
            onClick={close}
          >
            Cancel
          </button>

            <button  disabled={dfuserfromdropdown==""}
              className="button"
              style={{ marginLeft : "auto", marginRight : "auto"}}
              type="button"
              onClick={closeSubmit}
            >
              <FormattedMessage id="nav.ok" defaultMessage="OK" />
            </button>
          </div>
          )}
        </ModalFooter>
      </Modal>
    </a>
  );
}

export default ModalExample3;



// WEBPACK FOOTER //
// ./src/components/views/ManagementDFuser/popfooter.js